import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SourceField = ({
  id,
  title,
  draggable,
  handleDragStart,
  isRemoveAllowed,
  removeField,
  fieldMapping,
}) => (
  <div
    draggable={draggable ? "true" : "false"}
    onDragStart={handleDragStart}
    className="sf-tag">
    {title}
    {isRemoveAllowed && (
      <i>
        <FontAwesomeIcon
          icon={["far", "times"]}
          onClick={() => {
            removeField(id, fieldMapping);
          }}
          className=""
        />
      </i>
    )}
  </div>
);

SourceField.defaultProps = {
  handleDragStart: () => {},
  draggable: false,
};

export default SourceField;
